import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { RouterModule } from '@angular/router';
import { GeneratePasswordFormComponent } from 'src/app/shared/component/generate-password/generate-password-form.component';

@NgModule({
  declarations: [GeneratePasswordFormComponent],
  exports: [GeneratePasswordFormComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    RouterModule,
    MatInputModule,
  ],
})
export class GeneratePasswordFormModule {}
